/**
 * Lista de pares clave/valor para las cabeceras de detalle. Densa a proposito:
 * en diagnostico se leen muchos campos cortos de una sola pasada.
 */
import type { ReactElement, ReactNode } from 'react';

export interface KeyValueItem {
  readonly label: string;
  readonly value: ReactNode;
}

export function KeyValueList({ items }: { readonly items: readonly KeyValueItem[] }): ReactElement {
  return (
    <dl className="kv">
      {items.map((item) => (
        <div key={item.label} className="kv__row">
          <dt className="kv__key">{item.label}</dt>
          <dd className="kv__value">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
